/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { houseDuocolor } from "../assets/house-duocolor";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconHouseDuocolor = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={houseDuocolor.svg} />
);

IllustrativeIconHouseDuocolor.displayName = "IllustrativeIconHouseDuocolor";
